import React from 'react';
import About from './About';
import DownloadApp from './DownloadApp';
import Footer from './Footer';
import HeroCarousel from './HeroSlider/HeroCarousel';
import Mani from './Mani';
import Membership from './Membership';
import Mining from './Mining';
import OurMission from './OurMission';
import Papers from './Papers';
import Timeline from './Timeline';

const Home = () => {
    return (
        <div className='overflow-hidden'>
            <HeroCarousel />
            <About />
            <OurMission />
            <Mining />
            <Mani />
            <DownloadApp />
            <Membership />
            <Timeline />
            <Papers />
            <Footer />
        </div>
    );
};

export default Home;